import TimeBase from "./TimeBase";

const Embaixadores = () => {
  return (
    <TimeBase
      pageSlug="embaixadores"
      timeNomeKey="TimeBase.EmbaixadorNomeKey"
      timeDescricaoKey="TimeBase.EmbaixadorDescricaoKey"
      tipo="EMBAIXADOR"
    />
  );
};

export default Embaixadores;
